import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { CmpsTaskListDialogModule } from '../dialog';

import { TaskListNavButtonComponent } from './task-list-nav-button.component';
import { TranslationIdMap } from './task-list-nav-button.i18n';

@NgModule({
    declarations: [TaskListNavButtonComponent],
    exports: [TaskListNavButtonComponent],
    imports: [
        CmpsButtonModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTaskListDialogModule,
        CmpsTooltipModule,
        CommonModule,
    ],
})
export class CmpsTeamsCallTaskListNavButtonModule {}
